import Immutable from 'immutable';
import { List } from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  currentService: null,
  services: List()
})

export default handleActions({
  GET_SERVICE: (state, action) => {
    return state.merge({currentService: action.payload})
  },
  SERVICE_LIST: (state, action) => {
    return state.merge({services: action.payload})
  },
}, defaultState)
